import { Component } from '@theme/component';

class DisclosureCustom extends Component {
  requiredRefs = ['disclosureTrigger', 'disclosureContent'];

  connectedCallback() {
    super.connectedCallback();
    requestAnimationFrame(() => {
      const trigger = this.querySelector('[ref="disclosureTrigger"]') ?? this.refs?.disclosureTrigger;
      const content = this.querySelector('[ref="disclosureContent"]') ?? this.refs?.disclosureContent;
      if (trigger && content) {
        content.inert = trigger.getAttribute('aria-expanded') !== 'true';
      }
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  toggleDisclosure = () => {
    const trigger = this.querySelector('[ref="disclosureTrigger"]') ?? this.refs.disclosureTrigger;
    const content = this.querySelector('[ref="disclosureContent"]') ?? this.refs.disclosureContent;
    if (!trigger || !content) return;
    const expanded = trigger.matches('[aria-expanded="true"]');
    trigger.setAttribute('aria-expanded', String(!expanded));
    trigger.setAttribute(
      'aria-label',
      `${expanded ? trigger.dataset.disclosureOpen : trigger.dataset.disclosureClose}`
    );
    content.inert = expanded;
  };
}

if (!customElements.get('disclosure-custom')) {
  customElements.define('disclosure-custom', DisclosureCustom);
}